// extracted by mini-css-extract-plugin
export default {"shadowElement":"NewTable_shadowElement__Gbxea"};